<script setup>
import { ref, watch } from 'vue'
import store from '@/store'
import { userService } from '@/http'
import { useRouter } from 'vue-router'

import ImageUpload from '@/Components/ImageUpload.vue'


const router = useRouter()

const form = ref({})

console.log(store)

const item = ref({})

const onSave = async () => {
  userService.update({...store.user}).then(data => {
    console.log(data)
  })
}

const onUpload = () => {
  onSave()
}

const onDelete = () => {
  userService.delete().then(data => {
    store.logout()
  })
}

const logout = () => {
    store.logout()
}

</script>

<template>
    <form class="my" @submit.prevent="onSave">
        <div class="my__photo">
            <ImageUpload @upload="onUpload" v-model="store.user.photo" icon="user" />
        </div>
        <h1 class="my__name">
            {{ store.user.name }}
        </h1>
        <div class="my__edit">
            <v-input v-model="item.title" label="Новый пароль" />
            <button class="btn btn--full" type="submit">
                Сменить
            </button>
            <button class="btn btn--light btn--full" @click.prevent="logout">
                Выйти
            </button>
            <button class="btn btn--full" @click.prevent="onDelete">
                Удалить
            </button>
        </div>
    </form>
</template>

<style lang="scss">
.my {
    display: flex;
    flex-direction: column;
    gap: 20px;

    &__name {
        text-align: center;
        font-size: 32px;
    }
    &__photo {
        width: 100px;
        margin: 0 auto;
    }
    &__edit {
        display: flex;
        flex-direction: column;
        gap: 20px;
    }
}
</style>